export const fixture = Object.freeze({
  snapshot: {
    id: 'nordwerk-static-v1',
    created: '2026-08-28',
    nature: 'synthetic',
    company: 'NordWerk Gebäudetechnik GmbH',
  },
  customers: [
    { id: 'C-1001', name: 'Elbquartier Hausverwaltung GmbH', address: 'Am Sandtorkai 38', postalCode: '20457', city: 'Hamburg', email: 'technik@elbquartier.example', status: 'Beispielkunde' },
    { id: 'C-1002', name: 'Kita Sonnenbogen e. V.', address: 'Sievekingsallee 122', postalCode: '20535', city: 'Hamburg', email: 'buero@sonnenbogen.example', status: 'Beispielkunde' },
    { id: 'C-1003', name: 'Mertens & Sohn Werkstätten KG', address: 'Billstraße 91', postalCode: '20539', city: 'Hamburg', email: 'werkstatt@mertens-sohn.example', status: 'Beispielkunde' },
  ],
  proposals: [
    {
      id: 'AN-2026-1001', customerId: 'C-1001', date: '2026-08-04', validUntil: '2026-08-18', status: 'Angenommen',
      orderId: 'AU-2026-1001',
      lines: [
        { code: 'SRV-WP', description: 'Wärmepumpen-Wartung', quantity: 2, unitNet: 420 },
        { code: 'FIL-F7', description: 'Lüftungsfilter F7', quantity: 6, unitNet: 38.5 },
        { code: 'ANF-HH', description: 'Anfahrt Hamburg', quantity: 1, unitNet: 68 },
      ],
    },
    { id: 'AN-2026-1002', customerId: 'C-1002', date: '2026-08-20', validUntil: '2026-09-03', status: 'Nicht versendet', orderId: null, lines: [{ code: 'SRV-WP', description: 'Wärmepumpen-Wartung', quantity: 1, unitNet: 420 }, { code: 'FIL-F7', description: 'Lüftungsfilter F7', quantity: 4, unitNet: 38.5 }, { code: 'ANF-HH', description: 'Anfahrt Hamburg', quantity: 1, unitNet: 48 }] },
  ],
  orders: [
    { id: 'AU-2026-1001', customerId: 'C-1001', proposalId: 'AN-2026-1001', invoiceId: 'RE-2026-1001', date: '2026-08-06', status: 'Bestätigt', linesFrom: 'AN-2026-1001' },
  ],
  invoices: [
    { id: 'RE-2026-1001', customerId: 'C-1001', orderId: 'AU-2026-1001', date: '2026-08-12', dueDate: '2026-08-26', paymentTermDays: 14, status: 'Nicht versendet', linesFrom: 'AN-2026-1001' },
  ],
  materials: [
    { id: 'FIL-F7', name: 'Lüftungsfilter F7', unitNet: 38.5, quantity: 1, minimum: 8, location: 'Hauptlager Hamburg' },
    { id: 'VENT-24', name: 'Stellantrieb 24 V', unitNet: 129, quantity: 12, minimum: 4, location: 'Hauptlager Hamburg' },
    { id: 'SEN-TEMP', name: 'Temperatursensor PT1000', unitNet: 46, quantity: 18, minimum: 6, location: 'Servicefahrzeug HH-NW 12' },
    { id: 'PUMP-25', name: 'Hocheffizienzpumpe 25/1-6', unitNet: 289, quantity: 5, minimum: 2, location: 'Hauptlager Hamburg' },
  ],
  kita: {
    defaultRequest: 'Guten Tag, bei unserer Wärmepumpe steht die jährliche Wartung an. Bitte planen Sie auch den Austausch von vier F7-Filtern ein und senden Sie uns ein Angebot inklusive Anfahrt. Durchführung möglichst in den nächsten zwei Wochen. Viele Grüße, Kita Sonnenbogen.',
    netTotal: 622,
    vatRate: 0.19,
    requiredFilters: 4,
    vehicleFilters: 0,
    warehouseFilters: 1,
    reservedFilters: 0,
  },
});

